import { defer, EMPTY, Observable } from "rxjs"
import { Router } from "../../../server/router"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import {
    PASSWORD_RESET_FORM_SUBMITTED,
    PASSWORD_RESET_REQUESTED,
    PASSWORD_RESET_SUCCESS,
    passwordResetFailure,
    passwordResetRequested,
    passwordResetSuccess,
} from "./actions"
import { createLoadingEnded, createLoadingStarted } from "../../filters/actions"
import { createEventRequest, requestEvent } from "../../../events/utils"
import { getHttpHeaders } from "../../auth/selectors"
import { EventType } from "../../../events/types"
import { EventDataResponse } from "../../../graphql/types"
import { NotificationType, openNotification } from "../../uiKit/Notification/Notification"
import { Action, StateObject } from "../../redux/types"
import { ofType, StateObservable } from "redux-observable"
import { catchError, switchMap } from "rxjs/operators"

export const passwordResetSubmittedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_FORM_SUBMITTED),
        switchMap((action: Action) => [
            createLoadingStarted("password-reset"),
            passwordResetRequested(action.payload.email, action.payload.token, action.payload.newPassword),
        ])
    )

export const passwordResetRequestedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_REQUESTED),
        switchMap((action: Action) => {
            return defer(() =>
                requestEvent(
                    getHttpHeaders(deps.getState()),
                    createEventRequest(
                        EventType.PasswordChangeRequested,
                        {
                            correlationId: deps.idgen.next(),
                        },
                        {
                            email: action.payload.email,
                            key: action.payload.token,
                            password: action.payload.newPassword,
                        },
                        0
                    )
                )
            ).pipe(
                switchMap((res: EventDataResponse) => {
                    const id = res?.id
                    if (!id) {
                        throw new Error("passwordResetRequestedEpics - Id is missing")
                    }

                    return [createLoadingEnded("password-reset"), passwordResetSuccess()]
                }),
                catchError(error => {
                    openNotification(NotificationType.Error, "Password reset request not successful", `${error}`)
                    return [createLoadingEnded("password-reset"), passwordResetFailure(error)]
                })
            )
        })
    )

export const passwordResetSuccessEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_SUCCESS),
        switchMap(() => {
            Router.push("/login?passwordReset=true")
            return EMPTY
        })
    )
export default [passwordResetSubmittedEpics, passwordResetRequestedEpics, passwordResetSuccessEpics]
